var _rect, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRfzoIconWithBorder = function SvgRfzoIconWithBorder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 2.5,
    fill: "white",
    stroke: "#464A53"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2949 6H11.8112C10.8035 6 9.79589 6.41725 9.07208 7.14745C8.2915 7.90745 7 9.68078 7 9.68078H14.2949H16.7643C17.772 9.68078 18.7796 9.26353 19.5035 8.53333C20.284 7.77333 21.5897 6 21.5897 6H14.2949Z",
    fill: "#016136"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17.3404V19.9333C7 20.9914 7.39739 22.0494 8.09281 22.8094C8.83081 23.629 10.5197 24.9851 10.5197 24.9851V17.3404V14.7475C10.5197 13.6894 10.1223 12.6314 9.42689 11.8714C8.68889 11.0518 7 9.68079 7 9.68079V17.3404Z",
    fill: "#B11016"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8007 25H20.2702C21.2778 25 22.2855 24.5828 23.0093 23.8526C23.7899 23.0777 25.0814 21.3043 25.0814 21.3043H17.8007H15.3312C14.3236 21.3043 13.3159 21.7216 12.5921 22.4518C11.8115 23.2267 10.52 25 10.52 25H17.8007Z",
    fill: "#7BA8DA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0949 15.0902V15.4478C25.0949 14.3898 24.6975 13.3317 24.0021 12.5717C23.2641 11.7521 21.5752 10.3961 21.5752 10.3961V15.0902V16.2674C21.5752 17.3255 21.9726 18.3835 22.668 19.1435C23.406 19.9631 25.0949 21.3192 25.0949 21.3192V15.0902Z",
    fill: "#BBCCEA"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRfzoIconWithBorder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rfzo-icon-with-border.f979a083.svg";
export { ForwardRef as ReactComponent };